/* =========================================================
   珂玺资本 — bilingual content data
   Exposed on window.SiteData
   ========================================================= */

window.SiteData = {
  brand: {
    cn: "珂玺资本",
    en: "KEXI CAPITAL",
    fullCn: "深圳前海珂玺资本管理有限公司",
    fullEn: "Shenzhen Qianhai Kexi Capital Management Co., Ltd.",
    tagline: {
      cn: "耐心资本 · 陪跑硬科技",
      en: "Patient Capital · Hard Tech",
    },
    descShort: {
      cn: "聚焦半导体与硬科技的耐心资本",
      en: "Patient capital for hard tech and semiconductors",
    },
  },

  nav: [
    { id: "home", cn: "首页", en: "Home" },
    { id: "about", cn: "关于", en: "About" },
    { id: "invest", cn: "投资", en: "Invest" },
    { id: "studio", cn: "智库", en: "Studio" },
    { id: "news", cn: "动态", en: "Insights" },
    { id: "bp", cn: "BP 通道", en: "Submit BP" },
    { id: "careers", cn: "招聘", en: "Careers" },
    { id: "contact", cn: "联系", en: "Contact" },
  ],

  // Sub-tabs inside "投资" page
  investTabs: [
    { id: "strategy", cn: "投资策略", en: "Strategy" },
    { id: "portfolio", cn: "投资组合", en: "Portfolio" },
    { id: "cases", cn: "上市案例", en: "IPO Cases" },
  ],

  stats: [
    {
      num: "20", suffix: "x", cn: "澜起科技解禁退出收益率", en: "Return on Montage Tech exit", index: "01",
    },
    {
      num: "15", suffix: "支", suffixEn: "funds", cn: "已备案基金", en: "Registered funds", index: "02",
    },
    {
      num: "20", suffix: "亿", suffixEn: "B RMB", cn: "管理规模（人民币）", en: "Assets under management", index: "03",
    },
    {
      num: "7", suffix: "+", cn: "已上市与即将上市企业", en: "Listed & soon-to-list companies", index: "04",
    },
  ],

  // Investment sectors
  sectors: [
    {
      num: "01",
      cn: "半导体",
      en: "Semiconductors",
      desc: {
        cn: "聚焦集成电路设计、半导体材料、设备及配套耗材全产业链。从澜起科技到基本半导体，覆盖国产替代核心节点。",
        en: "Full-stack focus on IC design, semiconductor materials, equipment and consumables — from Montage Tech to Basic Semi, anchoring China's domestic substitution.",
      },
      examples: ["澜起科技", "思特威", "慧智微", "基本半导体", "盾源聚芯", "矽睿科技"],
    },
    {
      num: "02",
      cn: "人工智能 & 智能驾驶",
      en: "AI & Intelligent Driving",
      desc: {
        cn: "围绕车规级 SoC、智能驾驶解决方案、AI 基础设施与智算云布局下一代计算与感知能力。",
        en: "Automotive-grade SoCs, intelligent driving stacks and AI infrastructure — investing in the compute layer of the autonomous decade.",
      },
      examples: ["黑芝麻智能", "佑驾创新", "九章云极", "蜻蜓智能"],
    },
    {
      num: "03",
      cn: "生物医疗",
      en: "Biotech & Life Sciences",
      desc: {
        cn: "基因测序仪、再生医学与生物制造设备 —— 从底层平台到临床转化，把握生命科学长周期机会。",
        en: "Sequencing platforms, regenerative medicine and bio-manufacturing — backing the platforms that underpin tomorrow's clinical translation.",
      },
      examples: ["真迈生物", "华源再生医学"],
    },
    {
      num: "04",
      cn: "智能智造 & 商业航天",
      en: "Smart Manufacturing & Aerospace",
      desc: {
        cn: "高端制造、3D 打印、商业航天与先进材料 —— 投资中国制造向上突破的技术原点。",
        en: "Advanced manufacturing, 3D printing, commercial aerospace and frontier materials — the technology roots of China's industrial ascent.",
      },
      examples: ["快造科技", "镭利电子", "中天晶科"],
    },
  ],

  // Listed companies (已上市案例)
  listed: [
    {
      year: "2019",
      ipoYear: "2019.07",
      ticker: "688008",
      market: "科创板",
      marketEn: "STAR Market",
      cn: "澜起科技",
      en: "Montage Technology",
      glyph: "澜起",
      desc: {
        cn: "国际领先的数据处理及互连芯片设计公司，内存接口芯片全球三强之一，市场份额 45% 位列行业之首。",
        en: "World-leading data-processing and interconnect IC designer. One of only three global players in memory interface chips, holding 45% market share.",
      },
      ret: "20",
      retLabel: { cn: "倍收益完美退出", en: "exit multiple" },
      story: {
        cn: "2017 年珂玺资本入局参投，2019 年澜起作为首批 25 家科创板公司挂牌上市，开盘当天突破千亿市值，2020 年 7 月解禁，以 20 倍左右收益完美退出。",
        en: "Kexi invested in 2017. Montage listed on the inaugural STAR batch in 2019, broke ¥100 B market cap on day one, and we fully exited at roughly 20× upon the 2020 lock-up release.",
      },
      sector: "半导体 · Semiconductors",
    },
    {
      year: "2020",
      ipoYear: "2022.05",
      ticker: "688213",
      market: "科创板",
      marketEn: "STAR Market",
      cn: "思特威",
      en: "SmartSens",
      glyph: "思特威",
      desc: {
        cn: "CMOS 图像传感器先进供应商，覆盖安防监控、机器视觉、智能车载等场景。",
        en: "Advanced CMOS image sensor designer for security, machine vision and automotive applications.",
      },
      ret: "50",
      retLabel: { cn: "%已解禁退出", en: "% post-lockup return" },
      story: {
        cn: "2020 年与国家集成电路产业基金、小米长江、招银国际、红杉资本同轮参投，2022 年上市仅一年半 —— 珂玺所投项目中 IPO 最快的一个，首日最高涨幅 79.82%。",
        en: "Co-invested in 2020 alongside the National IC Fund, Xiaomi Yangtze, CMB International and Sequoia. Listed in just 18 months — our fastest IPO to date, peaking +79.82% on day one.",
      },
      sector: "半导体 · Semiconductors",
    },
    {
      year: "2021",
      ipoYear: "2023.05",
      ticker: "688512",
      market: "科创板",
      marketEn: "STAR Market",
      cn: "慧智微",
      en: "Smarter Micro",
      glyph: "慧智微",
      desc: {
        cn: "持续领先的 5G 射频前端方案供应商，全球首款可重构射频前端发明者。",
        en: "Pioneer of the world's first reconfigurable RF front-end and consistent leader in 5G RFFE solutions.",
      },
      ret: "—",
      retLabel: { cn: "已上市", en: "Listed" },
      story: {
        cn: "2021 年 10 月珂玺资本与红杉瀚辰、混沌投资共同参与 Pre-IPO 轮；2023 年 5 月 16 日科创板挂牌上市。",
        en: "Joined the pre-IPO round in October 2021 with Sequoia Hanchen and Chaos Investment. Listed on the STAR Market in May 2023.",
      },
      sector: "半导体 · Semiconductors",
    },
    {
      year: "2021",
      ipoYear: "2024.08",
      ticker: "2533.HK",
      market: "港交所",
      marketEn: "HKEX",
      cn: "黑芝麻智能",
      en: "Black Sesame Int'l",
      glyph: "黑芝麻",
      desc: {
        cn: "车规级计算 SoC 及智能汽车解决方案供应商，中国最早量产高算力自动驾驶 SoC 的企业之一。",
        en: "Automotive-grade compute SoC vendor and intelligent driving solution provider — one of China's earliest 100+ TOPS autonomous SoC producers.",
      },
      ret: "—",
      retLabel: { cn: "已退出", en: "Exited" },
      story: {
        cn: "2021 年 9 月与小米集团、天际资本、武岳峰资本同轮参投，2024 年 8 月 8 日港股上市，2025 年 12 月全面退出。",
        en: "Co-invested in September 2021 with Xiaomi, Skyrim Capital and Walden International. HKEX listing on Aug 8, 2024; full exit completed in December 2025.",
      },
      sector: "智能驾驶 · Intelligent Driving",
    },
    {
      year: "2023",
      ipoYear: "2024.12",
      ticker: "2431.HK",
      market: "港交所",
      marketEn: "HKEX",
      cn: "佑驾创新",
      en: "MINIEYE",
      glyph: "佑驾",
      desc: {
        cn: "全栈自研的智能驾驶软硬一体方案商，覆盖行车、泊车、座舱三大关键场景。",
        en: "Full-stack autonomous driving solution provider covering driving, parking and in-cabin scenarios.",
      },
      ret: "—",
      retLabel: { cn: "已上市", en: "Listed" },
      story: {
        cn: "2023 年 11 月 E 轮参投，2024 年 12 月港交所上市，2025 年 12 月已过解禁期，择机减持退出。",
        en: "Joined Series E in November 2023. Listed on HKEX in December 2024; lock-up cleared in December 2025, ready for measured exit.",
      },
      sector: "智能驾驶 · Intelligent Driving",
    },
    {
      year: "2022",
      ipoYear: "2025.08",
      ticker: "300572",
      market: "曲线借壳",
      marketEn: "Reverse Merger",
      cn: "矽睿科技",
      en: "QST Corp.",
      glyph: "矽睿",
      desc: {
        cn: "MEMS 智能传感器年度独角兽，加速度计、磁传感器、IMU 等全品类产线。",
        en: "Annual IC unicorn in MEMS smart sensors — accelerometers, magnetic sensors, IMUs and full sensor stacks.",
      },
      ret: "—",
      retLabel: { cn: "曲线借壳上市", en: "Backdoor listed" },
      story: {
        cn: "2021 年 2 月珂玺资本与小米、云锋基金、国科嘉和参投 IPO 前最后一轮，2025 年 8 月 6 日通过收购安车检测控制权完成曲线借壳。",
        en: "Joined the final pre-IPO round in February 2021 with Xiaomi, Yunfeng and Guoke Jiahe. Reverse-merged into Anche Inspection on Aug 6, 2025.",
      },
      sector: "半导体 · Semiconductors",
    },
    {
      year: "2021",
      ipoYear: "2026.03",
      ticker: "688781",
      market: "科创板",
      marketEn: "STAR Market",
      cn: "视涯科技",
      en: "Seeya Tech",
      glyph: "视涯",
      desc: {
        cn: "新一代半导体 OLEDoS 显示器方案提供商，国内 OLED 微显示领军企业。",
        en: "Next-generation semiconductor OLEDoS micro-display solution provider.",
      },
      ret: "—",
      retLabel: { cn: "新近上市", en: "Recent IPO" },
      story: {
        cn: "2021 年 7 月与上海航空产投、小米产投同轮参投，2026 年 3 月 25 日科创板挂牌上市。",
        en: "Co-invested in July 2021 with Shanghai Aviation Industry Investment and Xiaomi Industry. STAR-listed on March 25, 2026.",
      },
      sector: "半导体 · Semiconductors",
    },
  ],

  // Pre-IPO pipeline
  pipeline: [
    { cn: "基本半导体", en: "Basic Semi", status: { cn: "境外上市备案已批", en: "Offshore filing approved" }, sector: "碳化硅 · SiC", year: "2025" },
    { cn: "奉加科技", en: "Fengjia Tech", status: { cn: "拟提交港交所", en: "HKEX submission planned" }, sector: "高性能混合信号 · Mixed-signal IC", year: "2026" },
    { cn: "盾源聚芯", en: "Ferrotec Hi-purity", status: { cn: "拟申报创业板", en: "ChiNext filing planned" }, sector: "硅熔接耗材 · Silicon consumables", year: "2026" },
    { cn: "真迈生物", en: "GeneMind", status: { cn: "已启动股改", en: "Restructuring initiated" }, sector: "基因测序 · Sequencing", year: "2026" },
    { cn: "九章云极", en: "DataCanvas", status: { cn: "拟提交港交所", en: "HKEX submission planned" }, sector: "AI 智算 · AI Infrastructure", year: "2026" },
  ],

  // Timeline
  // 关于页 / 首页可换图片（占位时 url 为空，编辑后填入）
  about: {
    heroImage: { url: "", fit: "width" },
    homeImage: { url: "", fit: "width" },
  },

  timeline: [
    { yr: "2016", titleCn: "公司成立", titleEn: "Founded", body: { cn: "深圳前海珂玺资本管理有限公司成立，同年 12 月完成中基协备案登记，登记编码 P1060401。", en: "Kexi Capital is founded in Shenzhen Qianhai and registered with AMAC (Code P1060401) the same year." } },
    { yr: "2017", titleCn: "首战告捷", titleEn: "First Conviction", body: { cn: "投资集成电路设计龙头澜起科技，并参与早期项目妃鱼直播，奠定半导体与消费分流双轨。", en: "Anchored Montage Technology and joined early-stage darling Feiyu Live Commerce — twin tracks of hard tech and consumer signal." } },
    { yr: "2019", titleCn: "澜起 IPO", titleEn: "Montage IPO", body: { cn: "澜起科技作为首批 25 家科创板上市公司之一登陆 A 股，开盘当天破千亿市值。", en: "Montage debuts on the inaugural STAR Market batch and breaks ¥100 B market cap on day one." } },
    { yr: "2020", titleCn: "20 倍完美退出", titleEn: "20× Exit", body: { cn: "澜起科技解禁退出，珂玺资本投资收益率达 20 倍以上 —— 机构里程碑式的一战。", en: "Lockup release on Montage delivers a 20×+ realised return — a defining milestone for the firm." } },
    { yr: "2022", titleCn: "思特威光速上市", titleEn: "SmartSens Lists", body: { cn: "投资仅一年半，思特威登陆科创板，成为我们 IPO 最快的项目。", en: "Just 18 months from investment to IPO, SmartSens lists on STAR — our fastest cycle ever." } },
    { yr: "2024", titleCn: "首登港股", titleEn: "First HK Listing", body: { cn: "黑芝麻智能、佑驾创新先后在港交所挂牌上市，机构正式打通 A 股与港股双通道。", en: "Black Sesame and MINIEYE list on HKEX, opening Kexi's dual A-share / HK exit channel." } },
    { yr: "2026", titleCn: "持续兑现", titleEn: "Continued Delivery", body: { cn: "视涯科技 3 月科创板上市；基本半导体、九章云极等多家被投企业接力冲刺 IPO。", en: "Seeya lists on STAR in March; Basic Semi, DataCanvas and others queue up for the next wave." } },
  ],

  // Team
  team: [
    {
      cn: "王 珍",
      en: "Wang Zhen",
      role: { cn: "管理合伙人", en: "Managing Partner" },
      bio: {
        cn: "深耕一级市场超过 15 年，深度参与机构所有重大交易决策。半导体与硬科技领域资深投资人。",
        en: "15+ years in private markets; lead decision-maker on every major investment. Veteran investor across semiconductors and frontier tech.",
      },
      glyph: "珍",
    },
    {
      cn: "投资合伙人 A",
      en: "Investment Partner",
      role: { cn: "合伙人 · 半导体", en: "Partner · Semiconductors" },
      bio: {
        cn: "曾任职头部券商投行部，主导多个 Pre-IPO 阶段半导体项目，覆盖设计、材料及设备全产业链。",
        en: "Former investment banker at a top-tier securities firm; led multiple pre-IPO semiconductor deals across design, materials and equipment.",
      },
      glyph: "合",
    },
    {
      cn: "投资合伙人 B",
      en: "Investment Partner",
      role: { cn: "合伙人 · 智能驾驶", en: "Partner · Intelligent Driving" },
      bio: {
        cn: "聚焦智能驾驶、AI 计算与传感平台。主导黑芝麻智能、佑驾创新等项目的尽调与投后管理。",
        en: "Focuses on intelligent driving, AI compute and sensor platforms. Led diligence and post-investment on Black Sesame and MINIEYE.",
      },
      glyph: "驾",
    },
    {
      cn: "投资董事 C",
      en: "Investment Director",
      role: { cn: "董事 · 生物医疗", en: "Director · Life Sciences" },
      bio: {
        cn: "生物医学博士背景，专注基因测序、再生医学等长周期赛道，主导真迈生物、华源再生医学项目投资。",
        en: "PhD in biomedicine; focuses on sequencing and regenerative medicine. Led investments in GeneMind and HuaYuan Regenerative.",
      },
      glyph: "医",
    },
    {
      cn: "风控总监 D",
      en: "Risk Director",
      role: { cn: "总监 · 合规风控", en: "Director · Risk & Compliance" },
      bio: {
        cn: "前 Big4 审计经理，搭建机构完整的尽调、合规及投后监控体系，保障投资人资金安全。",
        en: "Former Big-4 audit manager; built the firm's diligence, compliance and post-investment monitoring framework.",
      },
      glyph: "控",
    },
    {
      cn: "运营总监 E",
      en: "Operations Director",
      role: { cn: "总监 · 投资者关系", en: "Director · Investor Relations" },
      bio: {
        cn: "负责 LP 关系维护与基金运营，确保每一支基金从募集、投资到退出的全流程顺畅。",
        en: "Owns LP relationships and fund operations end-to-end — from fundraising through deployment and exit.",
      },
      glyph: "运",
    },
  ],

  // News / Insights
  news: [
    { date: "2026.03.25", tag: { cn: "上市动态", en: "IPO" }, cn: "视涯科技正式登陆科创板，珂玺资本 2021 年 B 轮持续陪伴", en: "Seeya Tech debuts on STAR Market; Kexi's 2021 Series B comes full circle" },
    { date: "2026.02.18", tag: { cn: "行业洞察", en: "Insight" }, cn: "国产替代下一站：碳化硅、硅熔接耗材与 OLEDoS 三个被低估的细分", en: "Next leg of localisation: SiC, silicon-fusion consumables and OLEDoS" },
    { date: "2026.01.10", tag: { cn: "投资动态", en: "Deal" }, cn: "珂玺资本完成商业航天专项基金首关，规模 3 亿元", en: "Kexi closes first tranche of ¥300 M Commercial Aerospace Fund" },
    { date: "2025.12.28", tag: { cn: "上市动态", en: "IPO" }, cn: "基本半导体获境外上市备案通知书，碳化硅第一股呼之欲出", en: "Basic Semi clears offshore listing filing — China's first SiC pure-play approaches debut" },
    { date: "2025.12.15", tag: { cn: "行业洞察", en: "Insight" }, cn: "AI 智算云的资本周期：从训练侧到推理侧的迁徙", en: "The AI compute capex cycle: shifting from training to inference" },
    { date: "2025.11.11", tag: { cn: "投资动态", en: "Deal" }, cn: "奉加科技完成新三板挂牌，2026 年拟提交港交所上市申请", en: "Fengjia Tech lists on NEEQ; HKEX filing planned for 2026" },
    { date: "2025.10.30", tag: { cn: "公司动态", en: "Firm" }, cn: "珂玺资本组合基金二期完成首关，专注半导体加成长期", en: "Kexi Fund-of-Funds II first close; mandate doubled down on semis and growth" },
    { date: "2025.09.20", tag: { cn: "行业洞察", en: "Insight" }, cn: "智能驾驶 SoC 的竞争格局：算力之外，生态才是终局", en: "Beyond TOPS: ecosystems will decide the smart-driving SoC endgame" },
  ],

  // Careers
  careers: [
    {
      role: { cn: "投资经理 · 半导体方向", en: "Investment Manager · Semiconductors" },
      loc: { cn: "深圳 / 上海", en: "Shenzhen / Shanghai" },
      type: { cn: "全职", en: "Full-time" }, exp: { cn: "3-5 年", en: "3-5y" },
      responsibilities: {
        cn: ["主导半导体细分行业研究与赛道地图绘制", "完成被投企业的尽调、估值与投委会沟通", "持续跟踪行业头部公司与潜在投资标的", "支持已投企业的投后增值（融资、上下游对接）"],
        en: ["Lead semiconductor sub-sector research and market maps", "Drive diligence, valuation, and IC communication for targets", "Continuously track sector leaders and potential targets", "Support post-investment value-add (financing, supply-chain intros)"],
      },
      skills: {
        cn: ["3-5 年硬科技投资 / 投行 / 半导体战略部门经验", "对存储、模拟、功率、设备、材料中至少一个细分有深度认知", "英文工作语言；财务建模与估值熟练", "目标驱动、能独立推进项目"],
        en: ["3-5 years in hard-tech VC / IB / semiconductor strategy", "Depth in at least one of memory, analog, power, equipment, materials", "Working English; strong modeling and valuation", "Outcome-driven and able to run projects independently"],
      },
    },
    {
      role: { cn: "投资分析师 · AI & 智能驾驶", en: "Analyst · AI & Intelligent Driving" },
      loc: { cn: "深圳", en: "Shenzhen" },
      type: { cn: "全职", en: "Full-time" }, exp: { cn: "1-3 年", en: "1-3y" },
      responsibilities: {
        cn: ["跟踪 AI 算力、智能驾驶 SoC、感知算法等细分动态", "完成行业地图、竞品比较、项目初筛", "参与尽调访谈与会议纪要整理", "撰写投资备忘录与对外研究报告"],
        en: ["Track AI compute, autonomous SoC, perception algorithms", "Produce market maps, comp tables, and project triage", "Join diligence interviews and write meeting notes", "Draft investment memos and external research"],
      },
      skills: {
        cn: ["1-3 年 VC / 券商研究 / AI 行业实习或全职经验", "计算机 / 电子 / 自动化等理工背景优先", "对 LLM / 多模态 / 端侧 AI / 自动驾驶有判断力", "Python 与数据可视化基本能力"],
        en: ["1-3 years in VC / sell-side research / AI internships or full-time", "STEM background preferred (CS / EE / automation)", "Informed view on LLMs, multimodal, edge AI, autonomous driving", "Basic Python and data viz"],
      },
    },
    {
      role: { cn: "投后管理经理", en: "Portfolio Operations Manager" },
      loc: { cn: "深圳", en: "Shenzhen" },
      type: { cn: "全职", en: "Full-time" }, exp: { cn: "5-8 年", en: "5-8y" },
      responsibilities: {
        cn: ["统筹已投企业的财务、人事、合规与战略事项", "牵头被投企业的下一轮融资协调、对接战略股东", "跟踪关键运营指标，提交季度投后简报", "推动并购、上市辅导阶段的关键环节"],
        en: ["Coordinate finance, HR, compliance, and strategy across portfolio", "Lead next-round financing and strategic-shareholder intros", "Track operating KPIs; produce quarterly post-investment briefs", "Drive M&A and IPO-coaching milestones"],
      },
      skills: {
        cn: ["5-8 年 VC / PE 投后 / 战略咨询 / FA 投行经验", "对硬科技或医疗细分有较好的产业理解", "强协调与项目管理能力，能承担一线对接", "中英文流利，能直接对接外资 LP / 海外渠道"],
        en: ["5-8 years in VC/PE portfolio ops, strategy consulting, or FA/IB", "Solid industry sense in hard tech or healthcare", "Strong coordination and project management; front-line communication", "Fluent Chinese & English; comfortable with offshore LPs / channels"],
      },
    },
    {
      role: { cn: "投资者关系专员", en: "Investor Relations Associate" },
      loc: { cn: "深圳", en: "Shenzhen" },
      type: { cn: "全职", en: "Full-time" }, exp: { cn: "2-4 年", en: "2-4y" },
      responsibilities: {
        cn: ["维护 LP 长期关系，定期沟通基金运营与投资进展", "组织 LP 年度大会、单项目展示与现场考察", "完成季度 / 年度报告与 ESG / 合规披露", "协助新基金募资的资料准备与路演组织"],
        en: ["Manage long-term LP relationships; communicate fund and deal updates", "Organize LP AGM, single-project showcases, and site visits", "Produce quarterly / annual reports and ESG / compliance disclosures", "Support new-fund roadshow material preparation and logistics"],
      },
      skills: {
        cn: ["2-4 年 PE / 母基金 / 资管 IR 或客户经理经验", "出色的沟通、写作与演示能力，中英文俱佳", "熟悉私募基金运营、备案与合规框架", "细致、责任感强，能独立处理 LP 复杂询问"],
        en: ["2-4 years in PE / FoF / asset-management IR or relationship roles", "Outstanding communication, writing, and presentation in Chinese & English", "Familiar with private fund operations, filings, and compliance", "Detail-oriented; able to handle complex LP inquiries independently"],
      },
    },
    {
      role: { cn: "暑期实习生 · 行业研究", en: "Summer Intern · Research" },
      loc: { cn: "深圳", en: "Shenzhen" },
      type: { cn: "实习", en: "Internship" }, exp: { cn: "在校", en: "Student" },
      responsibilities: {
        cn: ["在投资经理指导下完成行业 / 公司研究任务", "整理被投公司公开信息、新闻与财报摘要", "支持尽调访谈记录与外部专家访谈整理", "撰写实习期内 1-2 篇高质量行业研究小报告"],
        en: ["Complete sector / company research under investment manager guidance", "Curate portfolio companies' public info, news, and earnings summaries", "Support diligence-interview transcripts and external-expert calls", "Author 1-2 high-quality short research reports during the internship"],
      },
      skills: {
        cn: ["国内外名校在读，硬科技 / 经济 / 金融背景优先", "每周可投入 ≥4 个工作日，连续 ≥3 个月", "中英文良好，能阅读英文行业报告", "强好奇心与学习能力"],
        en: ["Enrolled at top-tier university; STEM / econ / finance preferred", "Available ≥4 weekdays per week, for ≥3 consecutive months", "Solid Chinese & English; able to read English industry reports", "Strong curiosity and learning ability"],
      },
    },
  ],

  // Contact
  contact: {
    addr: { cn: "深圳市南山区紫光信息港 B 座 805 室", en: "Suite 805, Tower B, Tsinghua Unisplendour Info Port, Nanshan, Shenzhen" },
    person: { cn: "王 珍", en: "Wang Zhen" },
    phone: "+86 139 2286 6581",
    email: "ir@kexicapital.com",
    wechat: "kexicapital",
    hours: { cn: "周一至周五 · 9:30 – 18:30", en: "Mon – Fri · 09:30 – 18:30 CST" },
    geo: { lng: 113.947898, lat: 22.554921 },
    mapName: { cn: "珂玺资本 · 紫光信息港 B 座", en: "KEXI CAPITAL · Unisplendour Info Port Tower B" },
  },

  // Footer
  footer: {
    discl: {
      cn: "本网站所载信息仅供参考，不构成任何投资建议或要约。私募基金合格投资者需符合相关监管规定。",
      en: "Information on this site is for reference only and does not constitute investment advice. Private fund qualified investor rules apply.",
    },
  },

  // i18n strings
  i18n: {
    cn: {
      heroLead: "16 倍 IPO · 4 家科创板 · 2 家港股 · 5 家待上市",
      heroBody: "我们是一家专注于半导体、AI 与硬科技的私募股权投资机构。从澜起科技的 20 倍退出，到黑芝麻智能与佑驾创新的港股闭环，我们用时间换空间，做技术周期里的耐心资本。",
      ctaPrimary: "查看投资组合",
      ctaSecondary: "用户登录",
      sectionIntro: "公司简介",
      sectionStats: "业绩数字",
      sectionSectors: "投资赛道",
      sectionCases: "已上市案例",
      sectionPipeline: "Pre-IPO 储备",
      sectionPhilosophy: "投资理念",
      sectionTimeline: "公司发展历程",
      sectionTeam: "核心团队",
      sectionNews: "新闻与洞察",
      sectionContact: "联系我们",
      viewAll: "查看全部",
      readMore: "阅读全文",
      backTop: "回到顶部",
      investorLogin: "用户登录",
      submit: "提交",
      year: "年份",
      ticker: "代码",
      sector: "赛道",
      multiple: "回报",
      apply: "申请职位",
      location: "工作地点",
      experience: "经验",
    },
    en: {
      heroLead: "16× IPO · 4 STAR-Market · 2 HKEX · 5 in pipeline",
      heroBody: "Kexi Capital is a private equity firm focused on semiconductors, AI and hard tech. From a 20× exit on Montage Technology to full circles on Black Sesame and MINIEYE on the HKEX, we trade time for conviction — patient capital across the technology cycle.",
      ctaPrimary: "View portfolio",
      ctaSecondary: "User login",
      sectionIntro: "The Firm",
      sectionStats: "By the numbers",
      sectionSectors: "Sectors",
      sectionCases: "Listed companies",
      sectionPipeline: "Pre-IPO pipeline",
      sectionPhilosophy: "Philosophy",
      sectionTimeline: "Milestones",
      sectionTeam: "Team",
      sectionNews: "News & Insights",
      sectionContact: "Get in touch",
      viewAll: "View all",
      readMore: "Read more",
      backTop: "Back to top",
      investorLogin: "User login",
      submit: "Submit",
      year: "Year",
      ticker: "Ticker",
      sector: "Sector",
      multiple: "Return",
      apply: "Apply",
      location: "Location",
      experience: "Exp",
    },
  },

  // Philosophy pillars
  philosophy: [
    {
      num: "I",
      cn: "时间换空间",
      en: "Time over timing",
      body: { cn: "硬科技不是季度故事。我们用 5–10 年的视角守候技术成熟，不追逐风口。", en: "Hard tech isn't a quarterly story. We hold across 5–10 year arcs — not seasons." },
    },
    {
      num: "II",
      cn: "深度而非广度",
      en: "Depth over breadth",
      body: { cn: "我们只在自己理解的赛道里下注。十五支基金、九成集中在半导体与硬科技。", en: "We only invest where we understand. 15 funds, 90% concentrated in semis and frontier tech." },
    },
    {
      num: "III",
      cn: "陪跑而非套现",
      en: "Build, don't extract",
      body: { cn: "天使到 Pre-IPO 多轮加注，与创始人共担周期 —— 镭利电子 30 倍、妃鱼直播 100 倍来自此。", en: "From angel to pre-IPO we double down. 30× on LeiLi, 100× on Feiyu — both built over multiple rounds with the founders." },
    },
    {
      num: "IV",
      cn: "国产替代为锚",
      en: "Anchored in localisation",
      body: { cn: "中美科技博弈是十年级机会。我们沿着自主可控的核心节点系统布局。", en: "US-China decoupling is a decade-scale opportunity. We invest along China's domestic substitution roadmap." },
    },
  ],

  // -------------------------------------------------------
  // Studio (AI Research Service)
  // -------------------------------------------------------
  studio: {
    tagline: { cn: "上传资料 · 输出报告 · 沉淀展示", en: "Upload · Synthesise · Showcase" },
    // 珂玺智库独立站入口（后台可配置；url 留空则不显示）
    intelligence: {
      url: "https://intelligence.kexicapital.net",
      label: { cn: "进入珂玺智库站", en: "Visit Kexi Intelligence" },
      note: { cn: "研究报告 · 专题小站 · 已公开成果", en: "Research reports · project sites · public work" },
    },
    intro: {
      cn: "珂玺智库是我们的内部研究中台，现对合格 LP 与创始人开放：提交 PDF / Word / PPT 等资料，由我们投资团队 + AI 协同生成专业的尽调报告、市场地图与定制企业小站；所有产出沉淀在您的账户内，并可选择是否展示于本站案例区。",
      en: "Studio is our in-house research engine, now open to qualified LPs and founders. Submit PDF / Word / PPT materials and our investment team — with AI in the loop — synthesises diligence memos, market maps and bespoke company mini-sites. Outputs live in your account; share to our public showcase if you choose.",
    },
    steps: [
      { num: "01", cn: "上传资料", en: "Upload", body: { cn: "支持 PDF / DOCX / PPTX / XLSX / 网页链接。上传即加密留存。", en: "PDF · DOCX · PPTX · XLSX · URLs. Encrypted on receipt." } },
      { num: "02", cn: "AI × 人工", en: "AI × Human", body: { cn: "我们的调研员复核 AI 抽取的事实、行业图谱与财务逻辑，确保每一行数据可追溯。", en: "Our analysts vet AI-extracted facts, market maps and financial logic — every datapoint traceable." } },
      { num: "03", cn: "报告与小站", en: "Report + Site", body: { cn: "输出一份 12–30 页 PDF 研究报告，并生成一个定制企业小站，可分享、可对外。", en: "A 12–30 page PDF and a bespoke company mini-site — shareable, public if you want." } },
      { num: "04", cn: "沉淀与展示", en: "Archive & Showcase", body: { cn: "所有报告进入您的账号；您可选择是否将其加入珂玺公开案例展示区。", en: "Reports are archived in your account. Opt in to feature them on our public showcase." } },
    ],
    reports: [
      { co: { cn: "玄铁微电子", en: "XuanTie Micro" }, type: { cn: "Pre-A 尽调报告", en: "Pre-A diligence memo" }, sector: { cn: "半导体 · RISC-V", en: "Semi · RISC-V" }, pages: 28, date: "2026.04.12", featured: true },
      { co: { cn: "极境医疗", en: "JiJing Medical" }, type: { cn: "市场地图 + 站", en: "Market map + site" }, sector: { cn: "高值耗材", en: "Med-tech" }, pages: 22, date: "2026.04.05" },
      { co: { cn: "星辰云算", en: "Stellar Compute" }, type: { cn: "完整尽调包", en: "Full DD package" }, sector: { cn: "AI 智算云", en: "AI compute" }, pages: 36, date: "2026.03.28" },
      { co: { cn: "苍穹航天", en: "CangQiong Aero" }, type: { cn: "Pre-A 报告", en: "Pre-A memo" }, sector: { cn: "商业航天", en: "Aerospace" }, pages: 24, date: "2026.03.18" },
      { co: { cn: "光甲传感", en: "GuangJia Sensor" }, type: { cn: "技术路线分析", en: "Tech roadmap" }, sector: { cn: "MEMS", en: "MEMS" }, pages: 18, date: "2026.03.02" },
      { co: { cn: "云栖生命", en: "Yunqi Bio" }, type: { cn: "市场图谱", en: "Market map" }, sector: { cn: "再生医学", en: "Regen-med" }, pages: 20, date: "2026.02.20" },
    ],
    stats: [
      { num: "240", suffix: "+", cn: "累计完成报告", en: "Reports delivered" },
      { num: "48", suffix: "h", cn: "平均交付时长", en: "Avg turnaround" },
      { num: "96", suffix: "%", cn: "LP 满意度", en: "LP satisfaction" },
      { num: "32", suffix: "", cn: "公开案例", en: "Public cases" },
    ],
  },

  // -------------------------------------------------------
  // BP submission channel
  // -------------------------------------------------------
  bp: {
    tagline: { cn: "把你的事业 · 讲给我们听", en: "Tell us what you're building" },
    intro: {
      cn: "如果你正在做的是半导体、AI、生物医疗、智能智造或商业航天领域的硬科技公司，欢迎把你的 BP 直接交给我们。我们承诺 5 个工作日内由合伙人亲自反馈 —— 通过或不通过，都会说清楚理由。",
      en: "If you're building in semiconductors, AI, life sciences, smart manufacturing or commercial aerospace — send us your deck. A partner will reply within 5 business days with a clear yes, no, or what we'd need to see next.",
    },
    promises: [
      { num: "01.", cn: "合伙人亲自看", en: "Read by a partner", body: { cn: "每一份 BP 至少由一位合伙人完整阅读。", en: "Every deck gets read end-to-end by at least one partner." } },
      { num: "02.", cn: "5 个工作日内反馈", en: "5-business-day SLA", body: { cn: "不论结果如何，5 个工作日内一定有答复。", en: "Regardless of outcome, you get a reply within 5 business days." } },
      { num: "03.", cn: "明确理由", en: "Reasons given", body: { cn: "不通过会说明为什么；通过会告诉你下一步安排。", en: "If we pass, you'll know why. If we engage, you'll know the next step." } },
      { num: "04.", cn: "保密", en: "Confidential", body: { cn: "未签 NDA 的内容我们绝不外传，被投后亦严格隔离。", en: "Pre-NDA materials are never shared. Post-investment, strict information walls apply." } },
    ],
    sectors: [
      { cn: "半导体 · IC 设计 / 材料 / 设备", en: "Semiconductors · IC design / materials / equipment" },
      { cn: "AI 与智能驾驶", en: "AI & intelligent driving" },
      { cn: "生物医疗 / 基因测序 / 再生医学", en: "Life sciences / sequencing / regenerative medicine" },
      { cn: "智能智造 / 3D 打印 / 工业机器人", en: "Smart manufacturing / 3D printing / industrial robotics" },
      { cn: "商业航天 · 卫星 / 核心部件 / 先进材料", en: "Commercial aerospace · satellites / core components / advanced materials" },
      { cn: "其他硬科技", en: "Other hard tech" },
    ],
    stages: [
      { cn: "天使 / Pre-A", en: "Angel / Pre-A" },
      { cn: "A 轮 / A+", en: "Series A / A+" },
      { cn: "B 轮", en: "Series B" },
      { cn: "C 轮及以后", en: "Series C and later" },
      { cn: "Pre-IPO", en: "Pre-IPO" },
    ],
  },

  // Studio i18n
  i18nStudio: {
    cn: {
      uploadTitle: "上传你的资料",
      uploadHint: "拖入文件或点击选择 · 支持 PDF / DOCX / PPTX / MP3 · 单文件 ≤ 50MB",
      uploadCta: "选择文件",
      myReports: "我的报告",
      publicCases: "公开案例展示",
      empty: "你尚未提交任何资料",
      requestAccess: "申请开通",
      generate: "生成报告",
      share: "分享小站",
      download: "下载 PDF",
    },
    en: {
      uploadTitle: "Drop your files",
      uploadHint: "Drop files or click to browse · PDF / DOCX / PPTX / MP3 · ≤ 50 MB each",
      uploadCta: "Choose files",
      myReports: "My reports",
      publicCases: "Public showcase",
      empty: "No materials submitted yet",
      requestAccess: "Request access",
      generate: "Generate",
      share: "Share site",
      download: "Download PDF",
    },
  },
};
